import { Link } from "react-router-dom";
import { getHotComics } from "@/mocks/comics";

export default function HotComics() {
  const hotComics = getHotComics();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">大家都在看的漫画</p>
          </div>
          <Link
            to="/category/rexue"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6" data-product-shop>
          {hotComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group block"
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden bg-background-200 mb-3">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 51漫画免费下载`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded-full">
                    {comic.rating}
                  </span>
                </div>
                <div className="absolute top-2 right-2">
                  <span className="px-2 py-0.5 bg-background-900/70 text-white text-xs rounded-full">
                    {comic.status}
                  </span>
                </div>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}